// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner-module__spinner___mmMxR","spinner-border":"Spinner-module__spinner-border___2rQb2","spinnerSmall":"Spinner-module__spinnerSmall___V7-mw"};